import {
    END_POINT,
    ISession,
    PageInitiale,
    ParcoursEmprunteur,
    PersonneConnectee,
    StatutDemande
} from './useSessionApi';
import { getDateStr, getUserMockedFromUrlParams } from '../../../../utils';
import { mockInstance, withDelay } from '../../../../api/axiosInstance.mock';

const nextWeekDateStr = getDateStr(
    new Date(new Date().setDate(new Date().getDate() + 7))
);

const inSixDays = getDateStr(
    new Date(new Date().setDate(new Date().getDate() + 6))
);

export const dataCoEmprunteur1: ISession = {
    pageInitiale: PageInitiale.MODALITES,
    statutDemande: StatutDemande.INITIALE,
    langue: 'fr',
    approbationCoemprunteur: {
        delaiApprobation: 14,
        dateLimite: nextWeekDateStr,
        dateRappel: inSixDays
    },
    codeAvis: null,
    typeParcoursEmprunteur: ParcoursEmprunteur.COEMPRUNTEUR_GUY,
    dateSysteme: '20210128',
    contextePret: {
        idDemande: 12345,
        descriptionPerso: 'Description Pret Demande 12345 - pdo 00012345678'
    },
    contexteToggleFeature: {
        calculScenarioPaiement: true
    },
    personneConnectee: PersonneConnectee.MEMBRE
};

export const dataConseiller: ISession = {
    ...dataCoEmprunteur1,
    personneConnectee: PersonneConnectee.CONSEILLER
};

export const dataCoEmprunteur2: ISession = {
    ...dataCoEmprunteur1,
    typeParcoursEmprunteur: ParcoursEmprunteur.COEMPRUNTEUR_MARTINE,
    isMartine: true
};

export const dataCoEmprunteur2Retard: ISession = {
    ...dataCoEmprunteur2,
    codeAvis: 'AVIS_DATE_DEPASSEE'
};

export const dataEmprunteurUnique: ISession = {
    ...dataCoEmprunteur1,
    typeParcoursEmprunteur: ParcoursEmprunteur.UNIQUE
};

export const dataRenouvellementPresqueEnRetardUnique: ISession = {
    ...dataEmprunteurUnique,
    dateSysteme: '20210128',
    approbationCoemprunteur: {
        ...dataEmprunteurUnique.approbationCoemprunteur,
        dateRappel: '20210130'
    }
};

export const dataRenouvellementPresqueEnRetardGuy: ISession = {
    ...dataCoEmprunteur1,
    dateSysteme: '20210130',
    approbationCoemprunteur: {
        ...dataCoEmprunteur1.approbationCoemprunteur,
        dateRappel: '20210130'
    }
};

export const defineMockData = (useMockParam: string): ISession => {
    if (!useMockParam) return dataCoEmprunteur1;
    switch (useMockParam) {
        case 'conseiller':
            return dataConseiller;
        case 'coemprunteur2':
        case 'coemprunteur2InteretRetard':
        case 'coemprunteur2SignatureIntegree':
        case 'coemprunteur2OntarioSignatureIntegree':
            return dataCoEmprunteur2;
        case 'coemprunteur2Retard':
            return dataCoEmprunteur2Retard;
        case 'emprunteuruniqueHorsParcoursModaliteAucuneAssurance':
        case 'emprunteuruniqueontario':
        case 'emprunteuruniqueSignatureIntegreeDejaAssure':
        case 'emprunteuruniqueSignatureIntegreeAucuneAssurance':
        case 'emprunteuruniqueInteretRetard':
        case 'emprunteuruniqueontarioSignatureIntegree':
        case 'emprunteurUniqueSignatureIntegreeAjoutAssuranceAdmissibleVieEtInvaliditeParcours1':
        case 'emprunteurUniqueSignatureIntegreeAjoutAssuranceAdmissibleVieParcours1':
        case 'emprunteurUniqueSignatureIntegreeAjoutAssuranceAdmissibleVieEtInvaliditeParcours2':
        case 'emprunteurUniqueSignatureIntegreeAjoutAssuranceAdmissibleVieParcours2':
        case 'emprunteurUniqueSignatureIntegreeAjoutAssuranceAdmissibleVieEtInvaliditeParcours3':
        case 'emprunteurUniqueSignatureIntegreeAjoutAssuranceAdmissibleVieParcours3':
            return dataEmprunteurUnique;
        case 'renouvellementBientotEnRetartUnique':
            return dataRenouvellementPresqueEnRetardUnique;
        case 'renouvellementBientotEnRetartGuy':
            return dataRenouvellementPresqueEnRetardGuy;
        default:
            return dataCoEmprunteur1;
    }
};

export const useSessionApiMock = (): any => {
    const userMockParam = getUserMockedFromUrlParams();

    mockInstance
        .onGet(END_POINT)
        .reply(withDelay([200, defineMockData(userMockParam)], 100));
};
